import { Stack, StackProps, styled } from "@tm/components"
import { forwardRef } from "react"
import { classes } from "@tm/utils"
import { offerItemClasses, offerItemName, offerItemSlots } from "@tm/themes"

const OfferItemErpComponent = forwardRef<HTMLDivElement, StackProps>((props, ref) => (
    <Stack {...props} className={classes(offerItemClasses.erp, props.className)} ref={ref} />
))
export const OfferItemErp = styled(OfferItemErpComponent, {
    name: offerItemName,
    slot: offerItemSlots.erp,
    overridesResolver: (_, styles) => styles.erp,
})({
    gap: 4,
})
